import { Form, Button, Row, Col, Spinner } from 'react-bootstrap';
import styles from '../pa_chamados_sourcing.module.scss';
import { useContext } from 'react';
import { ChamadosSourcingContext } from '../pa_chamados_sourcing_context';
import SelectInput from '../../../Misc/SelectInput/SelectInput';

const FiltroChamadosSourcing = () => {
  const {
    formularioFiltro,
    setFormularioFiltro,
    carregarChamados,
    limparFiltros,
    loadingMainTable
  } = useContext(ChamadosSourcingContext);

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      minWidth: '164px',
      padding: '0',
      borderColor: state.isFocused ? '#2684FF' : '#ddd',
      boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : 'none',
      '&:hover': {
        borderColor: '#2684FF',
        cursor: 'pointer',
      },
      textAlign: 'left',
      cursor: 'pointer'
    }),
    menuPortal: provided => ({ ...provided, zIndex: 9999 })
  }

  return (
    <Form className={styles.filter_wrapper}>
      <Form.Group>
        <Form.Label className={styles.form_label}>ID Chamado</Form.Label>
        <Form.Control
          value={formularioFiltro.id_chamado || ''}
          onChange={e => setFormularioFiltro({ ...formularioFiltro, id_chamado: e.target.value })}
          className={styles.filter_input}
          placeholder='ID Chamado'
        />
      </Form.Group>

      <Form.Group className={styles.filter_input}>
        <Form.Label className={styles.form_label}>Nº Lacre Envio</Form.Label>
        <Form.Control
          value={formularioFiltro.lacre_envio || ''}
          onChange={e => setFormularioFiltro({ ...formularioFiltro, lacre_envio: e.target.value })}
          className={styles.filter_input}
          placeholder='Nº Lacre Envio'
        />
      </Form.Group>

      <Form.Group className={styles.filter_input}>
        <Form.Label className={styles.form_label}>CNPJ Fornecedor Principal</Form.Label>
        <Form.Control
          value={formularioFiltro.cnpj || ''}
          onChange={e => setFormularioFiltro({ ...formularioFiltro, cnpj: e.target.value })}
          className={styles.filter_input}
          placeholder='CNPJ Fornecedor Principal'
        />
      </Form.Group>

      <SelectInput
        label={'Categoria'}
        style={{ width: '164px' }}
        value={formularioFiltro.categoria || null}
        onChange={e => setFormularioFiltro({ ...formularioFiltro, categoria: e })}
        options={[
          { label: 'Novos Fornecedores', value: 'novo_fornecedor' },
          { label: 'Cadeia de Fornecimento', value: 'cadeia_fornecimento' }
        ]}
        customSelectStyles={customSelectStyles}
        isClearable={true}
      />

      <SelectInput
        label={'Status'}
        style={{ width: '164px' }}
        value={formularioFiltro.status_cq || null}
        onChange={e => setFormularioFiltro({ ...formularioFiltro, status_cq: e })}
        options={[
          { label: 'Novo', value: 'novo' },
          { label: 'Aguardando Análise CQ PA', value: 'em_analise' },
          { label: 'Concluído', value: 'concluido' },
          { label: 'Cancelado', value: 'cancelado' },
        ]}
        customSelectStyles={customSelectStyles}
        isClearable={true}
      />

      <SelectInput
        label={'Resultado C.Q.'}
        style={{ width: '164px' }}
        value={formularioFiltro.resultado || null}
        onChange={e => setFormularioFiltro({ ...formularioFiltro, resultado: e })}
        options={[
          { label: 'Aprovado', value: 'aprovado' },
          { label: 'Aprovado com Restrições', value: 'aprovado_com_restricoes' },
          { label: 'Reprovado', value: 'reprovado' }
        ]}
        customSelectStyles={customSelectStyles}
        isClearable={true}
      />

      <Form.Group>
        <Form.Label className={styles.form_label}>Data Início Criação</Form.Label>
        <Form.Control
          type="date"
          value={formularioFiltro.data_inicio || ''}
          onChange={e => setFormularioFiltro({ ...formularioFiltro, data_inicio: e.target.value })}
          className={styles.filter_input}
        />
      </Form.Group>

      <Form.Group>
        <Form.Label className={styles.form_label}>Data Fim Criação</Form.Label>
        <Form.Control
          type="date"
          value={formularioFiltro.data_fim || ''}
          onChange={e => setFormularioFiltro({ ...formularioFiltro, data_fim: e.target.value })}
          className={styles.filter_input}
        />
      </Form.Group>

      <Button
        variant="secondary"
        onClick={() => carregarChamados()}
        style={{ width: '164px', fontWeight: '500' }}
        className={styles.filter_input}
      >
        {
          loadingMainTable ? <Spinner animation="border" size="sm" /> : 'Filtrar'
        }
      </Button>

      <Button
        variant="warning"
        onClick={limparFiltros}
        style={{ width: '164px', fontWeight: '500' }}
        className={styles.filter_input}
      >
        Limpar Filtros
      </Button>
    </Form>
  );
}

export default FiltroChamadosSourcing;
